export const reviews = [
    {
        id: 1,
        img: 'Images/images.png',
        description: "Absolutely love these earrings! The design is so elegant and goes perfectly with both traditional and modern outfits. The quality feels premium and comfortable to wear all day.",
        name: "Sarojini",
        position: 'Madurai'
    },
    {
        id: 2,
        img: 'Images/images.png',
        description: "The hair bands are super comfortable and don’t hurt even after wearing for long hours. The designs are very cute and perfect for daily use.",
        name: "Hema",
        position: 'Coimbatore'
    },
    {
        id: 3,
        img: 'Images/images.png',
        description: "These hair clips hold my hair perfectly without slipping. Also, the colors and designs are really stylish and trendy.",
        name: "Rajeshwari",
        position: 'Salem'
    },
    {
        id: 4,
        img: 'Images/images.png',
        description: "The frames look so aesthetic and add a nice touch to my room. The quality is really good and worth the price.",
        name: "Sherin Taj",
        position: 'Trichy'
    },
    {
        id: 5,
        img: 'Images/images.png',
        description: "The resin art is absolutely beautiful and unique. You can clearly see the effort and detailing in the work.",
        name: "Sreema",
        position: 'Tirunelveli'
    },
    {
        id: 6,
        img: 'Images/images.png',
        description: "The pencil design is very cute and different from regular ones. Perfect for gifting or personal use.",
        name: "Raseena Farveen",
        position: 'Chennai'
    },
    {
        id: 7,
        img: 'Images/images.png',
        description: "I bought both hair clips and bands, and both are amazing quality. They stay in place and look really stylish.",
        name: "Jagasree",
        position: 'Vellore'
    },
    {
        id: 8,
        img: 'Images/images.png',
        description: "These earrings are perfect for daily wear. Simple, elegant, and very comfortable.",
        name: "Menaga",
        position: 'Erode'
    },
    {
        id: 9,
        img: 'Images/images.png',
        description: "The resin art with frame looks so premium and aesthetic. It really upgraded my room decor.",
        name: "Aravindh",
        position: 'Dindigul'
    },
    {
        id: 10,
        img: 'Images/images.png',
        description: "All the products feel unique and different from what I usually see. Really happy with the quality and design.",
        name: "Shiva",
        position: 'Kanyakumari'
    }
];
